module.exports = __webpack_public_path__ + "static/img/img_africa.cf3d9d5.cf3d9d5b.jpg";